import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from '../TextInput/TextInput.module.scss';
const ReadyOnlyInput = ({ className, value }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.wrapper, className) }, { children: _jsx("div", Object.assign({ className: cn(styles.element) }, { children: _jsx("input", { type: 'text', readOnly: true, value: value, className: className }) })) })));
};
export default ReadyOnlyInput;
